module.exports = __webpack_public_path__ + "img/logo.e820a67c.png";